import CategorySearch from 'marketing/components/CategorySearch';
import CategoryBrowse from 'marketing/components/CategoryBrowse';
import CategoriesScrollBehaviour from 'marketing/components/CategoriesScrollBehaviour';
import FullTextSearch from 'marketing/utils/FullTextSearch';
import { trackEvent } from 'common/utils/analytics';

document.addEventListener('DOMContentLoaded', () => {
    const searchBox = document.querySelector('[data-search-field]');
    const searchButtons = document.querySelectorAll('[data-search-button]');
    const browsePane =  document.querySelector('[data-browse-pane]');

    initializeTrackingForLinks(document);

    new CategorySearch(
        searchBox,
        document.querySelector('[data-search-results-count]'),
        document.querySelector('[data-search-results]'),
        initializeSearcher()
    );

    new CategoryBrowse();
    new CategoriesScrollBehaviour();

    searchBox.addEventListener('keyup', updateVisiblePane);

});

function updateVisiblePane(event) {
    const resultsPane = document.querySelector('[data-search-results-pane]');
    const browsePane =  document.querySelector('[data-browse-pane]');

    resultsPane.removeAttribute('data-hidden');
    browsePane.removeAttribute('data-hidden');

    if (event.currentTarget.value.length > 0) {
        browsePane.setAttribute('data-hidden', true);
    } else {
        resultsPane.setAttribute('data-hidden', true);
    }
}

function initializeSearcher() {
    const searchConfig = [
        {name: 'title', weight: 0.8},
        {name: 'parent', weight: 0.4},
        {name: 'keywords', weight: 0.2},
    ]
    const searchdocuments = readCategoriesData();
    const fallBackResult = searchdocuments.filter((doc) => { return doc.key === 'other-design' }).pop();

    return new FullTextSearch(searchdocuments, searchConfig, fallBackResult);
}

function readCategoriesData() {
    const categories = [];

    window.categories.forEach((category) => {
        const categoryNode = document.querySelector(`[data-category-${category.key}]`);

        if (categoryNode) {
            const clone = categoryNode.cloneNode(true);
            initializeTrackingForLinks(clone);

            categories.push({
                title: category.title,
                parent: category.parent_category_title,
                keywords: category.keywords.join(' '),
                node: clone,
                key: category.key
            });
        }
    });

    return categories;
}

function initializeTrackingForLinks(element) {
    const categoryLinks = element.querySelectorAll('[data-category-link]');

    Array.from(categoryLinks).forEach((categoryLink) => {
        categoryLink.addEventListener('click', trackClickedLink);
    });
}

function trackClickedLink(event) {
    const searchBox = document.querySelector('[data-search-field]');

    trackEvent('Clicked Link On Categories Page', {
        category: event.currentTarget.getAttribute('data-category-key'),
        searchTerm: searchBox ? searchBox.value : null
    });
}



// WEBPACK FOOTER //
// ./js/marketing/categories.js